import {makeRoute} from '$src/lib/helper';

export default {
    routes: [{
        path: '/',
        component: () => import(/* webpackChunkName: "landing" */ '$landing/layouts/LandingLayout'),
        children: [
            makeRoute('', 'landing', () => import(/* webpackChunkName: "landing" */ '$landing/views/LandingView'), {
                title: 'Anmeldung',
                isGuest: true,
            }),

            makeRoute('login', 'landing_login', () => import(/* webpackChunkName: "landing" */ '$landing/views/LoginView'), {
                title: 'Anmeldung',
                isGuest: true,
            }),

            makeRoute('register', 'landing_register', () => import(/* webpackChunkName: "landing" */ '$landing/views/RegisterView'), {
                title: 'Registrierung',
                isGuest: true,
            }),

            makeRoute('resend-activation/:id_user', 'landing_resend_activation', () => import(/* webpackChunkName: "landing" */ '$landing/views/ResendActivationView'), {
                title: 'Aktivierung',
                isGuest: true,
            }),

            makeRoute('activate/:id_user/:token', 'landing_activate_user', () => import(/* webpackChunkName: "landing" */ '$landing/views/ActivateUserView'), {
                title: 'Aktivierung',
                isGuest: true,
            }),

            makeRoute('password-forgotten', 'landing_password_forgotten', () => import(/* webpackChunkName: "landing" */ '$landing/views/PasswordForgottenView'), {
                title: 'Passwort vergessen',
                isGuest: true,
            }),

            makeRoute('password-reset/:id_user/:token', 'landing_password_reset', () => import(/* webpackChunkName: "landing" */ '$landing/views/PasswordResetView'), {
                title: 'Passwort vergessen',
                isGuest: true,
            }),

            makeRoute('impress', 'landing_impress', () => import(/* webpackChunkName: "landing" */ '$landing/views/ImpressView'), {
                title: 'Impressum',
            }),

            makeRoute('privacy', 'landing_privacy', () => import(/* webpackChunkName: "landing" */ '$landing/views/PrivacyView'), {
                title: 'Datenschutzerklärung',
            }),

            makeRoute('document/:hash', 'share_document', () => import(/* webpackChunkName: "landing" */ '$landing/views/ShareDocumentView'), {
                title: 'Dokumente',
            }),
        ],
    }],

    hooks: {
        async initial() {
            await Promise.all([
                import(/* webpackChunkName: "landing" */ '$landing/components'),
            ]);
        },

        beforeEnter() {
            this.$ui.titleTemplate = `%s - ${this.$env.isCommunity ? 'Wir sind START' : 'START Bewerbung'}`;
            this.$ui.defaultTitle = `${this.$env.isCommunity ? 'Wir sind START' : 'START Bewerbung'}`;
        },
    },
};